import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { HiExclamationCircle } from 'react-icons/hi';
import TransRaw from '../TransRaw';

interface Props {
  className?: string;
  children: React.ReactNode;
}

function FormError({ className, children }: Props): JSX.Element {
  // a cheeky workaround to prevent warnings from react-18next parser
  // https://github.com/i18next/i18next-parser/issues/657
  const { t: translate } = useTranslation();

  // do a slightly hacky workaround for translating form errors
  // by trying to detect if the children is a translation key or not
  // (has no spaces and has a period in it)

  // if prefixed with raw:, it will attempt to render it as raw HTML
  // (this is useful for rendering links in error messages)

  return (
    <div
      className={clsx('mt-2 flex items-center text-sm text-red-600', className)}
    >
      <HiExclamationCircle className="mr-1 h-4 w-4 flex-shrink-0 text-red-500" />
      {(() => {
        if (typeof children === 'string' && /^[^ ]+\.[^ ]+$/.exec(children)) {
          if (children.startsWith('raw:')) {
            return <TransRaw i18nKey={children.replace(/^raw:/, '')} />;
          }
          return translate(children);
        }
        return children;
      })()}
    </div>
  );
}

export default FormError;
